export type EmptyString = '';
export type NoValueString = null | undefined | EmptyString;

export function isNoValueString(obj: unknown): obj is NoValueString {
  return obj === '' || typeof obj === 'undefined' || obj === null;
}

export function isEmptyString(obj: unknown): obj is EmptyString {
  return obj === '';
}
